import { useState, useEffect } from '@wordpress/element';

let globalChecked = null;
let listeners = [];

export const useSharedOrderType = () => {
  const [checked, setChecked] = useState(globalChecked);

  useEffect(() => {
    const listener = (newValue) => {
      setChecked(newValue);
    };
    
    listeners.push(listener);
    
    // If there's a global value, update the local state
    if (globalChecked !== null) {
      setChecked(globalChecked);
    }

    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  }, []);

  const setGlobalChecked = (newValue) => {
    globalChecked = newValue;
    listeners.forEach(listener => listener(newValue));
  };

  return [checked, setGlobalChecked];
};
